// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1zUs-","bigColWidth":"Table_bigColWidth__1wN_j","biggerColWidth":"Table_biggerColWidth__pB7wT","row":"Table_row__2Ks5P","col":"Table_col__1wigB"};